export const SUPPORT_EMAIL = 'info@invictusgames.org';
const DOMAIN_DEVELOP = 'http://127.0.0.1:8000/api';
const DOMAIN_INT = 'https://admin.int.weareinvictus.global';
const DOMAIN_STAGING = 'https://admin.staging.weareinvictus.global';
const DOMAIN_PRODUCTION = 'https://admin.weareinvictus.global';

const env = process.env.NODE_ENV;

let apiDomain = DOMAIN_DEVELOP;
if (env === 'int') {
  apiDomain = DOMAIN_INT;
} else if (env === 'staging') {
  apiDomain = DOMAIN_STAGING;
} else if (env === 'production') {
  apiDomain = DOMAIN_PRODUCTION;
}

export const API_DOMAIN = apiDomain;
